export function latLngAreValid(
  lat: string | number | null | undefined,
  lng: string | number | null | undefined
): boolean {
  if (lat == null || lng == null) return false;

  const latNum =
    typeof lat === 'string'
      ? lat.trim() === ''
        ? NaN
        : Number(lat)
      : lat;
  const lngNum =
    typeof lng === 'string'
      ? lng.trim() === ''
        ? NaN
        : Number(lng)
      : lng;

  if (!Number.isFinite(latNum) || !Number.isFinite(lngNum)) return false;

  return latNum >= -90 && latNum <= 90 && lngNum >= -180 && lngNum <= 180;
}